var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.btnFlag)?_c('a',{staticClass:"allgoTop",attrs:{"href":"javaScropt:"},on:{"click":_vm.backTop}},[_c('img',{attrs:{"src":require("img/book/top.svg"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }